import { CommandParameterTemplate } from '../commandParameterTemplate/commandParameterTemplate';
import { FlowTemplate } from '../flowTemplate/flowTemplate';

export class CommandTemplate {

  name: string | undefined;
  settings: any | undefined;
  parameters: CommandParameterTemplate[] | undefined;
  flow: FlowTemplate | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.settings = payload.settings;
      if(payload.parameters){
        this.parameters = new Array<CommandParameterTemplate>();
        payload.parameters.map( (parameter: any) => {
          this.parameters.push(new CommandParameterTemplate(parameter));
        })
      }
      if(payload.flow){
        this.flow = new FlowTemplate(payload.flow);
      }
    }
  }

  getCommandProviderId(): string | undefined {
    let commandProviderId = this.parameters?.filter(
      parameter => parameter.name === 'commandProviderId'
    )?.[0]?.value;
    return commandProviderId;
  }
}

export class CommandInput {

  name: string;
  parameters: any | undefined;

  addParameter(name: string, value: any){
    if(!this.parameters){
      this.parameters = {};
    }
    this.parameters[name] = value;
  }
}
